import { CreateSubscriptionDto, UpdateSubscriptionDto } from "types/dto/CreateSubscriptionDto";
import { ApiService } from "./apiService";


export const cancelSubscription = async (userId: number) => {
  return await ApiService.delete(`subscriptions/${userId}`);
}

export const createSubscription = async (dto: CreateSubscriptionDto) => {
  const { data } = await ApiService.post(`subscriptions`, dto);
  return data;
};

export const UpdateSubscription = async (dto: UpdateSubscriptionDto) => {
  const { data } = await ApiService.put(`subscriptions/${dto.subscription_id}`, dto);
  return data;
};